import React from 'react';
import './navbar.scss'
import { ReactComponent as Logo } from '../../../../assets/svg/flo-logo.svg';
import { Button } from '@material-ui/core';
import { NavLink, useLocation } from 'react-router-dom';
import { makeStyles } from "@material-ui/core/styles";
import { matchPath } from "react-router";
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';
import { useSelector } from "react-redux";


const useStyles = makeStyles(theme => ({
  listContainer: {
    width: '100%',
    listStyleType: 'none',
    padding: 0,
    "& li": {
      // padding: '2em 0',
      borderBottom: '1px solid #979797'
    },    
  },
  subListContainer: {
    width: '100%',
    listStyleType: 'none',
    paddingLeft: "1em",
    "& li": {
      // padding: '2em 0',
      // borderBottom: '1px solid #979797'
      borderBottom: 'none'
    },    
    "& li:last-child": {
      marginBottom: "2em"
    }
  },
  menuItem:{
    color: 'white',
    width: "100%",
    height: "100%",
    margin: 0,
    padding: 0,
    lineHeight: "4em",
    textTransform: "none",
    fontSize: "1.1rem",
    justifyContent: "flex-start",
  },
  menuNoClickeable:{
    color: 'white !important',
    width: "100%",
    height: "100%",
    margin: 0,
    padding: 0,
    lineHeight: "4em",
    textTransform: "none",
    fontSize: "1.1rem",
    justifyContent: "flex-start",
    pointerEvents: "none",
    opacity: 0.5
  },
  menuSubItem:{
    color: 'white',
    width: "100%",
    height: "100%",
    margin: 0,
    padding: 0,
    lineHeight: "1.7em",
    textTransform: "none",
    fontSize: "1rem",
    justifyContent: "flex-start",      
  },
  externalArrow: {
    position: "absolute",
    left: "-23px",
    fontSize: "1em"
  },
  meuItemActive: {
    color: '#c2bbbb !important'
  }

}));

function MenuItem({to, name, className, exact = false, disabled = false}) {
  const location = useLocation();
  const classes = useStyles();  

  const active = matchPath(location.pathname, {
    path: to,
    exact,
    strict: false
  });

  return(
    <Button 
      className={className} 
      component={NavLink}  
      to={to} 
      disabled={disabled}
      activeClassName={!!active ? classes.meuItemActive: null}>
        {!!active ? <ArrowForwardIosIcon className={classes.externalArrow}/>: null}        
       {name}
    </Button>
  )  
}

function NavBar() {
  const classes = useStyles();
  const { data } = useSelector( state => state.user );
  
  return (  
    <div id="navbar">
      <NavLink to="/dashboard">
        <Logo />
      </NavLink>

      <div className="menu">
        <ul className={classes.listContainer}>
          {data && data.profile === 'manager' ?
          (
            // User's menu
            <li> 
              <MenuItem name="Users" to={`/dashboard/users`} className={classes.menuItem} exact={true}/>
              <ul className={classes.subListContainer}>
                <li><MenuItem name="Admin" to={`/dashboard/users/managers`} className={classes.menuSubItem}/></li>
                <li><MenuItem name="Managers/Educators" to={`/dashboard/users/teachers`} className={classes.menuSubItem}/></li>
                <li><MenuItem name="Staff/Members" to={`/dashboard/users/students`} className={classes.menuSubItem}/></li>              
              </ul>            
            </li>           
          ): null}
          
          <li> <MenuItem name="Groups" to={`/dashboard/courses`} className={classes.menuItem}/> </li>        

          {/* <li> <MenuItem name="Enrollments" to={`/dashboard/courses-students`} className={classes.menuItem}/> </li>        */}
          <li> <MenuItem name="Modules" to={`/dashboard/syllabus`} className={classes.menuItem}/> </li>                    
          {data && (data.profile === 'manager' || data.profile === 'teacher') && (
            <li> <MenuItem name="Permissions" to={`/dashboard/permissions`} className={classes.menuItem}/> </li>
          )}
          {data && data.profile === 'manager' ?
          (
            // Integration menu
            <li> 
              <MenuItem name="Integrations" to={`/dashboard/integrations`} className={classes.menuNoClickeable} exact={true} disabled={true}/>
              <ul className={classes.subListContainer}>
                <li><MenuItem name="LMS" to={`/dashboard/integrations/lms`} className={classes.menuSubItem}/></li>
                <li><MenuItem name="Scheduler System" to={`/dashboard/integrations/ss`} className={classes.menuSubItem}/></li>
              </ul>   
            </li>          
          ): null}
        </ul>         
      </div>
    </div>  
  )
}

export default NavBar;